import './common/css/App.css';
import {  Routes,  Route } from "react-router-dom";
import Login from "./login";
import Profile from "./profile";
import Myekukka from "./pages/myeKukka";
import UserAgreement from "./pages/userAgreement";
import React, { useState } from 'react';
import ScrollToTop from "./components/ScrollToTop";
import './css/gdpr.css';

const initialReturnPage = {
  lastEkukkaPage: 'ekukka.fi',
  refererSet: 0
}
function App() {
	const [returnPage, returnPageUpdate] = useState(initialReturnPage)
	//const [searchParams, setSearchParams] = useSearchParams();
	const queryParameters = new URLSearchParams(window.location.search)

  var urlParams = "";
	if (queryParameters.get("referer") !== null){
		urlParams = "?referer="+queryParameters.get("referer");
	}

  if (queryParameters.get("referer") !== null && !returnPage.refererSet) {
  	  var lastPage = (queryParameters.get("referer"));
  	  console.log('Referer: ', lastPage );
  		returnPageUpdate(() => ({ lastEkukkaPage: lastPage, refererSet: true}))

        console.log('Referer2: ', returnPage );
  }
  if (queryParameters.get("function") === "info"){
    window.location.href = 'https://' + window.location.hostname + '/myEkukka' + urlParams + '&ref=shop'
    return;
  }
	function backToShop(){
    console.log('Referer2: ', returnPage );
		if ( returnPage.lastEkukkaPage === null || returnPage.lastEkukkaPage === '' ){
			window.location.href="https://ekukka.fi/"
		}
		else {
      if (returnPage.lastEkukkaPage.includes("https://")){
  			window.location.href= returnPage.lastEkukkaPage
      }
      else {
        window.location.href= "https://" + returnPage.lastEkukkaPage
      }
		}
	}
	return(
			<>
				<ScrollToTop/>
			 	<Routes>
			 	 <Route exact path="/profile/*" element=<Profile backToShop={() => backToShop()} urlParams={urlParams}/> />
				 <Route path="/*" element=<Login backToShop={() => backToShop()} urlParams={urlParams}/>/>
				 <Route path="/myeKukka" element={<Myekukka backToShop={() => backToShop()}  urlParams={urlParams}/> }/>
				 <Route path="/userAgreement" element={<UserAgreement backToShop={() => backToShop()}  urlParams={urlParams}/> }/>
			 	</Routes>
			</>

	)
}

export default App;
